import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import { getDriverCalendarDetails, isHistoryChanged } from '../../../../services/DriverCalendarHistory';
import { historyAccessMessage } from '../../../../services/HistoryErrors';

export default function DriverHistoryDetails({ driverId, report }) {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({});
  useEffect(() => {
    if (!open) return undefined;
    let active = true;
    const controller = new AbortController();
    setState({ loading: true });
    getDriverCalendarDetails({
      driverId, page, selection: report.selection, snapshot: report.snapshot, signal: controller.signal,
    }).then((data) => {
      if (active) setState({ data });
    }, (error) => {
      if (!active) return;
      if (isHistoryChanged(error)) report.conflict(error);
      else setState({ error });
    });
    return () => { active = false; controller.abort(); };
  }, [open, driverId, page, attempt, report]);
  const access = historyAccessMessage(state.error);
  return <Box pb={0.5}>
    <Button size="small" aria-expanded={open} onClick={() => {
      setOpen(!open); setPage(1); setState({});
    }}>{open ? 'Close details' : 'Details'}</Button>
    {open && <Box pl={1}>
      {state.loading && <Typography role="status">Loading details…</Typography>}
      {state.error && <><Typography role="alert">{access || 'Could not load details.'}</Typography>
        {!access && <Button size="small" onClick={() => setAttempt(attempt + 1)}>Retry details</Button>}</>}
      {state.data && <>
        {!state.data.results.length && <Typography>No orders</Typography>}
        {state.data.results.map((order) => <Typography key={order.orderId}>
          Order {order.orderId}
        </Typography>)}
        {state.data.totalPages > 1 && <Pagination size="small" page={page}
          count={state.data.totalPages} onChange={(_, value) => setPage(value)} />}
      </>}
    </Box>}
  </Box>;
}
